/* eslint-disable no-console */
import firebase from 'firebase';
import store from '@/store';

const firebaseConfig = {
  apiKey: "AIzaSyBo92_6xRZAmHNVwUh8p99JzhdV2Y64VC0",
  authDomain: "urlinx-beta.firebaseapp.com",
  databaseURL: "https://urlinx-beta.firebaseio.com",
  projectId: "urlinx-beta",
  storageBucket: "urlinx-beta.appspot.com",
  messagingSenderId: "362919864457",
  appId: "1:362919864457:web:723335ed1c50b78b"
};
const appFirebase = firebase.initializeApp(firebaseConfig);

firebase.auth().onAuthStateChanged((user) => {

	store.dispatch('authStateChanged', {user:user});

});


// export { appFirebase as default, firebase };
export default appFirebase;